import { processPayment } from 'apis/controllers/membership';
import { useSnackbar } from 'notistack';
import SimpleDialog from 'qubCommon/Dialogs/SimpleDialog';
import { usePayment } from 'qubCommon/hooks/usePayment';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate } from 'react-router';

const PaymentModal = ({ open, handleClose, totalAmount }) => {
    const { t } = useTranslation();
    const { submitPayment } = usePayment();
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();

    const handlePayment = async () => {
        const res = await processPayment();
        console.log('res', res);
        try {
            if (res?.status === 'success') {
                if (res?.data?.paidAmount === 0) {
                    enqueueSnackbar(t('paymentSuccessfull'), { variant: 'success' });
                    navigate(0);
                } else submitPayment(res?.data);
            } else enqueueSnackbar(t(res?.message), { variant: t(res?.status) });
        } catch (e) {
            console.log(e);
            enqueueSnackbar(t('ErrorOccured')), { variant: 'error' };
        }
    };

    return (
        <SimpleDialog
            open={open}
            onClose={handleClose}
            title={t('Checkout')}
            description={totalAmount === 0 ? t('ProceedToZeroPaymentQuestion') : t('ProceedToPaymentQuestion')}
            onAccept={handlePayment}
        />
    );
};

export default PaymentModal;
